import { Center, Stack, ThemeIcon, Text, Button } from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { canAccess, allowedSections, Section } from '../lib/permissions';

/** Sahifani rol ruxsatiga qarab himoyalaydi. Ruxsat yo'q bo'lsa — ogohlantirish. */
export function Guard({ section, children }: { section: Section; children: React.ReactNode }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (canAccess(user?.role, section)) return <>{children}</>;

  const first = allowedSections(user?.role)[0];
  return (
    <Center h="70vh">
      <Stack align="center" gap="sm">
        <ThemeIcon size={64} radius="xl" variant="light" color="red"><IconLock size={32} /></ThemeIcon>
        <Text fw={600} size="lg">{t('guard.denied')}</Text>
        <Text c="dimmed" size="sm" ta="center" maw={320}>
          {t('guard.deniedMsg')}
        </Text>
        {first && <Button variant="light" onClick={() => navigate(`/${first === 'dashboard' ? '' : first}`)}>{t('guard.goHome')}</Button>}
      </Stack>
    </Center>
  );
}
